import React from 'react'
import Backbutton from '../../containers/Common/Backbutton';
import DisplayEmployeeName from '../DisplayEmployeeName';
import DropdownComponent from "../../containers/Dropdown";
import * as utilities from "../../utilities/utils";
import { useEffect } from 'react';
import { USER_ROLES } from '../../App.config';
import ReportModalContainer from '../../containers/Report/ReportModal';
import { MODAL_SIZE } from '../../App.config';
import swal from 'sweetalert';

const Report = (props) => {

    const openReportModal = () => {
        props.openSetModalAction(<ReportModalContainer closeRemoveModal={props.closeRemoveModal} selectedCompany={selectedCompany} GetReportsByCompany={GetReportsByCompany} />, MODAL_SIZE.MODAL_MD)
    }

    const {
        GetReportsByCompany,
        userAuthReducer,
        UpdateReportAccess
    } = props;

    let {
        reports
    } = userAuthReducer;

    const [selectedCompany, setSelectedCompany] = React.useState(undefined);

    const onDropDownChange = (event) => {
        setSelectedCompany(utilities.extractFirstValueOfArray(event.value));
    }

    useEffect(() => {
        GetReportsByCompany(selectedCompany);
    }, [selectedCompany, props.i18nReducerLang])

    const onDeleteReport = (report) => {
        swal({
            title: "Are you sure you want to delete the report",
            // text: "Once deleted, you will not be able to recover this!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    props.deleteReport(selectedCompany, report.reportId);
                }
            })
    }

    return (
        <>
            <section className="Dashboard-container">

                <div className="Content-Container">

                    <div className="Dashboard-Content">
                        <div className='card'>
                            <div className='card-body'>
                                <div className="row">
                                    <div className="col-md-8 mb-3">
                                        <label>Select Company</label>
                                        <DropdownComponent
                                            name="companyList"
                                            options={props.userAuthReducer.companyList}
                                            isMultiSelect={false}
                                            option_key="companyId"
                                            option_display="companyName"
                                            onChange={onDropDownChange}
                                            values={[selectedCompany]}
                                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                            selectAllText="Select All Options"
                                            isSearchOption={true}
                                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                        // ref={state.location.ref}
                                        />
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="back-btn-outer">

                                {/* <Backbutton /> */}
                            </div>
                        </div>
                        {selectedCompany && <div className="Inner-cell">
                            {/* <DisplayEmployeeName context={props.context} /> */}

                            <div className="Panel-cell">
                                <div className="Panel-header">
                                    Report Access Configuration
                                </div>
                                <div className="panel-content">
                                    <div className="Custom-form">
                                        <div className="col-md-12 text-right">
                                            <div className="mb-2 d-inline-block">
                                                <button type="button" className="btn btn-primary w-9"
                                                    onClick={() => openReportModal()}
                                                >Add Report</button>
                                            </div>
                                        </div>

                                        <table className='table table-striped'>
                                            <thead>
                                                <tr>
                                                    <th>Reports</th>
                                                    <th>Module</th>
                                                    <th>ADMIN</th>
                                                    <th>FULL HR</th>
                                                    <th>HR</th>
                                                    <th>MANAGER</th>
                                                    <th>BROKER</th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    Array.isArray(reports) && reports.length > 0 && reports.map((gr) => (
                                                        <>
                                                            <tr>
                                                                <td colSpan={8} className='module-td'>{gr.moduleName}</td>
                                                            </tr>
                                                            {gr && gr.groupedReports && gr.groupedReports.map((report) => (
                                                                <tr>
                                                                    <td>{report.reportName}</td>
                                                                    <td>{report.moduleName}</td>
                                                                    <td>
                                                                        <label class="switch">
                                                                            <input type="checkbox" onClick={() => { UpdateReportAccess(report.reportId, selectedCompany, USER_ROLES.ADMIN, !report.access.filter(x => x.roleId === USER_ROLES.ADMIN)[0].isAccess) }} checked={report.access.filter(x => x.roleId === USER_ROLES.ADMIN)[0].isAccess} />
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                    </td>
                                                                    <td>
                                                                        <label class="switch">
                                                                            <input type="checkbox" onClick={() => { UpdateReportAccess(report.reportId, selectedCompany, USER_ROLES.FULL_HR, !report.access.filter(x => x.roleId === USER_ROLES.FULL_HR)[0].isAccess) }} checked={report.access.filter(x => x.roleId === USER_ROLES.FULL_HR)[0].isAccess} />
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                    </td>
                                                                    <td>
                                                                        <label class="switch">
                                                                            <input type="checkbox" onClick={() => { UpdateReportAccess(report.reportId, selectedCompany, USER_ROLES.LIMITED_CAL_HR, !report.access.filter(x => x.roleId === USER_ROLES.LIMITED_CAL_HR)[0].isAccess) }} checked={report.access.filter(x => x.roleId === USER_ROLES.LIMITED_CAL_HR)[0].isAccess} />
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                    </td>
                                                                    <td>
                                                                        <label class="switch">
                                                                            <input type="checkbox" onClick={() => { UpdateReportAccess(report.reportId, selectedCompany, USER_ROLES.LIMITED_CAL_MGR, !report.access.filter(x => x.roleId === USER_ROLES.LIMITED_CAL_MGR)[0].isAccess) }} checked={report.access.filter(x => x.roleId === USER_ROLES.LIMITED_CAL_MGR)[0].isAccess} />
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                    </td>
                                                                    <td>
                                                                        <label class="switch">
                                                                            <input type="checkbox" onClick={() => { UpdateReportAccess(report.reportId, selectedCompany, USER_ROLES.BROKER, !report.access.filter(x => x.roleId === USER_ROLES.BROKER)[0].isAccess) }} checked={report.access.filter(x => x.roleId === USER_ROLES.BROKER)[0].isAccess} />
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                    </td>
                                                                    <td>
                                                                        <button className='btn' onClick={() => onDeleteReport(report)}>Delete</button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    ))
                                                }
                                                {
                                                    Array.isArray(reports) && reports.length == 0 && <>
                                                        <tr>
                                                            <td className='text-center' colSpan="7">No Report Available</td>
                                                        </tr>
                                                    </>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Report;